import React, { useEffect, useState } from 'react';
import { TopBar } from '../../components/layout/TopBar';
import { InferenceFile, MatchingEntity, DocumentReference, FileWithUrl } from '../../types';
import { DetailContainer } from '../../components/layout/DetailContainer';
import { Spinner } from '../../components/loading/Spinner';
import { Layout } from 'antd';
import { Matching } from './Matching';
import { MiniSidebar } from './MiniSidebar';
import { MatchingDetailView } from './MatchingDetailView';
import api from '../../config/AxiosService';

const { Content } = Layout;

type Props = {
  inferenceFile: InferenceFile | null;
  goBack: () => any;
};

export const MatchOverview = ({ inferenceFile, goBack }: Props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const [selectedMatching, setSelectedMatching] = useState<MatchingEntity | null>(null);
  const [detailMatching, setDetailMatching] = useState<{ entity: MatchingEntity; page: number } | null>(null);

  const [presignedUrls, setPresignedUrls] = useState<FileWithUrl[]>([]);
  const [documents, setDocuments] = useState<DocumentReference[]>([]);
  const [numPages, setNumPages] = useState<{ source: number; match: number }>({ source: 0, match: 0 });

  useEffect(() => {
    if (inferenceFile?.inferenceResult?.result?.matching?.length) {
      setSelectedMatching(inferenceFile?.inferenceResult?.result?.matching[0]);
    } else {
      setSelectedMatching(null);
    }
  }, [inferenceFile]);

  useEffect(() => {
    const fetchStats = async () => {
      if (inferenceFile) {
        try {
          setLoading(true);
          const statusResponse = await api.get(`/api/${inferenceFile?.id}/status`);
          setPresignedUrls(statusResponse.data.info.files);
          setError(false);
        } catch (e) {
          setError(true);
          setPresignedUrls([]);
        } finally {
          setLoading(false);
        }
      }
    };
    fetchStats();
  }, [inferenceFile]);

  const handleClick = (matching: MatchingEntity) => {
    setSelectedMatching(matching);
  };

  return (
    <>
      <TopBar
        title={`Document Matcher Result: ${inferenceFile?.fileId}`}
        closeFunction={(event: any) => {
          event.preventDefault();
          event.stopPropagation();
          goBack();
        }}
      />
      {loading && <Spinner />}
      {!loading && !error ? (
        <DetailContainer>
          <MiniSidebar
            matchings={inferenceFile?.inferenceResult.result.matching || []}
            handleClick={handleClick}
            selectedMatching={selectedMatching}
          />
          <Layout>
            <Content>
              <div
                style={{
                  width: 'calc(100vw - 240px)',
                  height: window.innerHeight - 58 + 'px',
                  overflowY: 'auto',
                  position: 'relative',
                }}>
                {selectedMatching && (
                  <Matching
                    selectedMatching={selectedMatching}
                    setDetailMatching={setDetailMatching}
                    documents={documents}
                    setDocuments={setDocuments}
                    numPages={numPages}
                    setNumPages={setNumPages}
                    presignedUrls={presignedUrls}
                  />
                )}
              </div>
            </Content>
          </Layout>
        </DetailContainer>
      ) : null}
      {!loading && error && (
        <div className="flex justify-center items-center p-8">An error has occured while loading the files.</div>
      )}
      {detailMatching ? (
        <MatchingDetailView
          detailMatching={detailMatching}
          documents={documents}
          onCancel={() => {
            setDetailMatching(null);
          }}
          numPages={numPages}
        />
      ) : null}
    </>
  );
};
